module.exports = __webpack_public_path__ + "static/img/11.1323517.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/sp/11.png
// module id = J1wO
// module chunks = 0